"use client";

// Prices of advertising per month (the Cenik design). Advertising is not ordered on the site: the visitor writes to
// us and gets a personal offer, so nothing here is a button that orders.
const BY_MUNICIPALITY = [
  { title: "Manjša mesta", price: 10 },
  { title: "Večja mesta *", price: 20 },
  { title: "Ljubljana", price: 30 },
];
const WIDER = [
  { title: "Regijsko", price: 30 },
  { title: "Vse regije", price: 100 },
  { title: "Vse občine", price: 200 },
];
const LARGER_CITIES = "Maribor, Celje, Kranj, Koper, Novo mesto, Domžale, Velenje, Nova Gorica";
export const ADVERTISING_EMAIL = "info@osmrtnica.com";

function PriceBlock({ title, tone, text, rows }) {
  return (
    <section className="w-full">
      <div className={`${tone} flex h-[49px] items-center justify-between px-4 text-white`}>
        <h2 className="text-[18px] uppercase leading-[24px]">{title}</h2>
        <span className="text-[14px] text-white/70">Cena na mesec</span>
      </div>
      <div className="border-b-2 border-[#073545] shadow-md">
        {rows.map((row) => (
          <div
            key={row.title}
            className={`flex min-h-[86px] items-center justify-between gap-4 border-t border-[#E3E8EE] bg-[#FBFCFE] px-[26px] first:border-t-0 mobile:min-h-[91px] mobile:px-4 ${text}`}
          >
            <span className="text-[24px] leading-[28px] mobile:text-[20px] mobile:leading-[24px]">{row.title}</span>
            <span className="whitespace-nowrap text-[40px] font-[300] leading-[44px] mobile:text-[28px]">{row.price} €</span>
          </div>
        ))}
      </div>
    </section>
  );
}

const pill =
  "flex h-[52px] items-center justify-center rounded-full bg-gradient-to-b from-[#1E9BE8] to-[#0A6FB0] px-8 text-[16px] text-white shadow-custom-dark-bottom";

/**
 * The "Oglaševanje" tab of the Cenik page. `onShowIncluded` opens the existing "Kaj je vključeno" view.
 */
export default function CenikAdvertisingSection({ onShowIncluded }) {
  return (
    <div className="mx-auto flex w-full max-w-[485px] flex-col gap-y-[57px] px-[10px] pb-[72px] pt-4 text-[#414141] mobile:gap-y-[50px] [@media(min-width:744px)]:max-w-[778px] [@media(min-width:744px)]:px-4">
      <div>
        <h2 className="text-[32px] leading-[38px] text-[#000000] mobile:text-[28px]">Oglaševanje</h2>
        <p className="mt-8 text-[15px] leading-[24px]">
          Oglaševanje je mogoče v za to namenjenih sektorjih na strani osmrtnice ali pogrebi - logotip se pojavlja v
          izbrani občini <span className="text-[#EB1D1D]">IN</span> hkrati na posebni strani lokalnih partnerjev, kjer
          je mogoča prava predstavitev produktov. Oboje je vključeno v ceno.
        </p>
      </div>

      <div>
        <PriceBlock title="Po občinah" tone="bg-[#112D77]" text="text-[#112C77]" rows={BY_MUNICIPALITY} />
        <p className="mt-4 text-[14px] leading-[22px]">* Občine nad 25.000 preb: {LARGER_CITIES}</p>
      </div>

      <div>
        <PriceBlock title="Širše" tone="bg-[#640F6C]" text="text-[#640F6C]" rows={WIDER} />
        <p className="mt-4 text-[14px] leading-[22px]">
          * Vse navedene cene so za mesečno oglaševanje. Pri letnem naročilu sta dva meseca brezplačna.
        </p>
      </div>

      <p className="text-[15px] leading-[24px]">
        Občasno so mogoče še druge promocije. Kontaktirajte nas, da vam pripravimo ponudbo po meri.
      </p>

      <div className="flex flex-wrap justify-between gap-4 mobile:flex-col mobile:items-center">
        <a href={`mailto:${ADVERTISING_EMAIL}`} className={`${pill} min-w-[250px]`}>
          {ADVERTISING_EMAIL}
        </a>
        <button type="button" onClick={onShowIncluded} className={`${pill} min-w-[250px]`}>
          Kaj je vključeno
        </button>
      </div>
    </div>
  );
}
